<template>
  <div class="app-page">
    <Header ref="header" helpURL="studio/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
    
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <div class="dash-container">
          <OrganizationUsageSummary />
          <NewsList />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import NewsList from '@/components/News/NewsList.vue';
import OrganizationUsageSummary from '@/components/UserProfileComponent/OrganizationSettings/OrganizationUsageSummary.vue';
import { useRouter } from 'vue-router';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const projectList = computed(() => store.state.projects.projectList);

if (!projectList.value || projectList.value.length === 0) {
  const dataConnect = new DatastoreConnect();
  dataConnect.getProjectList()
    .then((resp) => {
      if (resp.error) {
        throw resp.error;
      }

      if (resp.result.length > 0) {
        store.commit('projects/setProjectList', resp.result);
        if (!store.state.projects.currentProject) {
          store.commit('projects/setCurrentProject', resp.result[0]);
        }
      }
      return [];
    })
    .catch((error) => {
      console.error(error);
    });
}

</script>

<style lang="scss" scoped>

.main-display-area {
  overflow-y: auto;
}

.dash-container {
  display: flex;
  flex-direction: row;


}

@media (max-width: $breakpoint-lg) {
  .dash-container {
    flex-direction: column;
  }
}



</style>
